// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyCV4Yzv2moh-cNuRiCYPH4IVm3nwf7z1sU",
    authDomain: "testing-portal-us.firebaseapp.com",
    projectId: "testing-portal-us",
    storageBucket: "testing-portal-us.appspot.com",
    messagingSenderId: "97096548064",
    appId: "1:97096548064:web:6c7a3d6884a73511989a85",
    measurementId: "G-MPSE0HVVB7"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);

export default app;